module.exports = __webpack_public_path__ + "video/1000_PAB_2021_ReCap.a7c9c939.vtt";